import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 w-full px-4 md:px-8 py-16 md:py-24 flex flex-col items-center justify-center text-center">
        <span className="w-16 h-16 mb-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
          <i className="ri-compass-3-line text-3xl"></i>
        </span>
        <p className="font-heading font-black text-5xl md:text-7xl text-background-400 select-none">404</p>
        <h1 className="mt-4 font-heading font-black text-2xl md:text-3xl text-foreground-950">
          这一页没有找到对应的内容
        </h1>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-md leading-relaxed">
          链接可能已经失效，或者地址被改动过了。回到首页，或者直接去看完整收录的 30 条大盘点。
        </p>
        <p className="mt-3 text-xs text-foreground-500 font-mono break-all">{location.pathname}</p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <Link
            to="/"
            className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            回到首页
          </Link>
          <Link
            to="/rankings"
            className="px-5 py-2.5 rounded-md border border-background-300 text-foreground-800 text-sm whitespace-nowrap hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看 30 条大盘点
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}